import { PRESELECTION_SEEDS } from 'client-portal/utils/clinicianSearch/facets/manifest';
import {
  commaSeparatedIntsForQueryParam,
  commaSeparatedStringsForQueryParam,
  parseCommaSeparatedInts,
  parseCommaSeparatedStrings,
} from 'client-portal/utils/clinicianSearch/comma-query-param';

function cullCsvAgainstStoreIds(csv, store, modelName) {
  let requested = parseCommaSeparatedStrings(csv).map(id => String(id ?? '').trim());
  if (!requested.length) {
    return null;
  }
  let known = new Set(
    store
      .peekAll(modelName)
      .toArray()
      .map(r => String(r.id))
  );
  let kept = requested.filter(id => known.has(id));
  return commaSeparatedStringsForQueryParam(kept);
}

function intCsvOrNull(value) {
  let ints = parseCommaSeparatedInts(value);
  return ints.length ? commaSeparatedIntsForQueryParam(ints) : null;
}

function seedValueFromPreselected(preselectedValue, valueType, store) {
  if (valueType === 'ints') {
    return intCsvOrNull(preselectedValue);
  }
  return cullCsvAgainstStoreIds(preselectedValue, store, 'cpt-code');
}

export function seedClinicianSearchFiltersFromPreselection(params, { store }) {
  let next = { ...params };

  for (let { param, preselectedKey, valueType } of PRESELECTION_SEEDS) {
    let preselectedValue = params[preselectedKey];
    if (!preselectedValue || params[param]) {
      continue;
    }

    let seeded =
      valueType === 'strings' && param === 'officeIds'
        ? cullCsvAgainstStoreIds(preselectedValue, store, 'office')
        : seedValueFromPreselected(preselectedValue, valueType, store);

    if (seeded) {
      next[param] = seeded;
    }
  }

  return next;
}

function filterSeedQueryParams(seededParams) {
  return Object.fromEntries(
    PRESELECTION_SEEDS.map(({ param }) => [param, seededParams[param] ?? null])
  );
}

export function clinicianSearchFilterSeedQueryParams(seededParams) {
  return filterSeedQueryParams(seededParams);
}
